var JoyProperty;
(function (JoyProperty) {
    JoyProperty["client"] = "client";
    JoyProperty["photoeditor"] = "photoeditor";
    JoyProperty["photographer"] = "photographer";
    JoyProperty["photosession"] = "photosession";
    JoyProperty["watermark"] = "watermark";
})(JoyProperty || (JoyProperty = {}));
export default JoyProperty;
//# sourceMappingURL=JoyProperty.js.map